var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.smAndDown)?_c('banner-card',{attrs:{"fields":_vm.fields}}):_vm._e(),(_vm.fields && _vm.file && _vm.file.url)?_c('div',{staticClass:"banner content-center",class:[
      { hero: _vm.hero },
      {'ma-6 mx-md-0': !_vm.hero },
      (_vm.siteConfig && _vm.siteConfig.navBottomBorderColor === 'green') ? 'border-yellow' : ''
    ],style:({
      backgroundImage: ("url('" + (_vm.file.url) + "')"),
      height: _vm.smAndDown ? '150px' : ''
    })},[(!_vm.smAndDown)?_c('banner-card',{attrs:{"fields":_vm.fields}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }